// * Latest react version specific
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client'

import './index.scss';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { BrowserRouter } from "react-router-dom";
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { persistStore } from 'redux-persist';
import { store } from './redux-store/store';
import { Toaster } from 'react-hot-toast';

import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { DrawSVGPlugin } from 'gsap/DrawSVGPlugin';

const persistedStore = persistStore(store);


const rootElement = document.getElementById('root')
const root = createRoot(rootElement)

gsap.registerPlugin(ScrollTrigger, DrawSVGPlugin)
gsap.defaults({
  ease: 'none'
})


root.render(
  <StrictMode>
    <Provider store={store}>
      <PersistGate loading={<h1>Loading</h1>} persistor={persistedStore}>
        <BrowserRouter>
          {/* <Redirect /> */}
          <App />
          <Toaster />
        </BrowserRouter>
      </PersistGate>
    </Provider>
  </StrictMode>,
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
